'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import connectDropTargetDecorator from '../draggable/connectDropTarget';
import connectDragSourceDecorator from '../draggable/connectDragSource';
import { jsx as _jsx } from "react/jsx-runtime";
class UIDragListItem extends Component {
  getChildContext() {
    const {
      connectDragSource
    } = this.props;
    return {
      connectDragSource
    };
  }
  render() {
    const {
      children,
      className,
      connectDragPreview,
      connectDropTarget,
      isDragging,
      style
    } = this.props;
    return connectDragPreview(connectDropTarget( /*#__PURE__*/_jsx("div", {
      className: className,
      style: isDragging ? Object.assign({}, style, {
        opacity: 0
      }) : style,
      children: children
    })));
  }
}
UIDragListItem.propTypes = {
  isDragging: PropTypes.bool,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  connectDropTarget: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  style: PropTypes.object
};
UIDragListItem.childContextTypes = {
  connectDragSource: PropTypes.func
};
const ConnectedDragListItem = connectDragSourceDecorator(connectDropTargetDecorator(UIDragListItem));
ConnectedDragListItem.propTypes = Object.assign({}, UIDragListItem.propTypes);
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ConnectedDragListItem.defaultProps = Object.assign({}, UIDragListItem.defaultProps);
export default ConnectedDragListItem;